// src/utils/onboardingProfile.js
// Helpers partagés par le parcours d'onboarding (§2-8).
// Source unique de vérité pour : le « type métier » déduit du profil, la route
// d'accueil de chaque métier (où mène « Continuer seul » / le retour), et le fait
// qu'un métier propose de reprendre un existant (dépôt → analyse → reco).
import { supabase } from "../lib/supabaseClient";

export function resolveProfileType(profile) {
  if (!profile) return "collectionneur";
  const role = (profile.role || "user").toLowerCase();
  if (profile.foundation_mode === true) return "fondation";
  if (["expert", "advisor", "art_advisor"].includes(role)) return "advisor";
  if (role === "family_office") return "family_office";
  if (role === "notaire") return "notaire";
  if (role === "partner" && (profile.partner_type || "").toLowerCase() === "insurance") return "assureur";
  return "collectionneur";
}

// Route « maison » de chaque métier (dashboard / espace principal).
const HOME_ROUTES = {
  collectionneur: "/my-collection",
  advisor: "/expert/dashboard",
  family_office: "/family-office/manage",
  fondation: "/foundation/dashboard",
  notaire: "/notaire",
  assureur: "/partner/insurance", // espace PARTENAIRE assureur (pas /insurance = page collectionneur)
};

export function metierHomeRoute(profileType) {
  return HOME_ROUTES[profileType] || "/my-collection";
}

// Métiers pour lesquels la première action EST le dépôt (le reste y accède en
// action secondaire « reprendre l'existant »). Le collectionneur commence par là.
export function isDepositPrimary(profileType) {
  return profileType === "collectionneur";
}

// Mappe un type métier → la clé de compteur pertinente dans onboarding_account_state().
const CONTENT_KEY = {
  collectionneur: "artworks",
  fondation: "collections",
  advisor: "advisor_clients",
  family_office: "families",
  notaire: "notaire_dossiers",
  assureur: "insurer_requests", // demandes d'assurance adressées à cet assureur
};

// Seuil « encore léger » par métier : en dessous, on continue d'aider
// (carte de démarrage sur le dashboard). Au-dessus, le compte est établi.
const LIGHT_MAX = {
  collectionneur: 10,
  fondation: 3,
  advisor: 3,
  family_office: 2,
  notaire: 2,
  assureur: 3,
};

// Récupère l'état du compte (compteurs par entité) en un appel. {} si erreur.
export async function getAccountState() {
  try {
    const { data, error } = await supabase.rpc("onboarding_account_state");
    if (error || !data) return {};
    return data;
  } catch {
    return {};
  }
}

// Compteur pertinent pour le métier (ex. collectionneur → nb d'œuvres).
export function metierCount(state, profileType) {
  const key = CONTENT_KEY[profileType];
  if (!key || !state) return 0;
  return Number(state[key] || 0);
}

// Compte « encore léger » (⇒ on continue de l'aider). Par défaut : oui.
export function isLightAccount(state, profileType) {
  const max = LIGHT_MAX[profileType];
  if (max == null) return true;
  return metierCount(state, profileType) < max;
}

// A DÉJÀ du contenu (⇒ pas « premiers pas », on ne force pas l'onboarding vide).
// Défensif : en cas d'erreur, renvoie false (ne bloque jamais l'onboarding).
export async function accountHasContent(profileType) {
  const key = CONTENT_KEY[profileType];
  if (!key) return false;
  const state = await getAccountState();
  return Number(state[key] || 0) > 0;
}
